var lists_default = {
  "fontElementMap": "xyOmQ",
  "orderedlist": "ZCtNk",
  "bulletedlist": "Ior1H",
  "listItem": "w4rN-"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
